export enum ContextualBarTypeEnum {
  ALTA = 'mp-contextual-bar-alta',
  BAIXA = 'mp-contextual-bar-baixa'
}
